import type { CSSProperties } from 'react';

// Folder-card gradients shared by the hero "organized" grid and the Control
// Center mocks. Palette mirrors the markflow-landing example.
export type FolderGradient = { from: string; to: string; letter: string };

export const FOLDER_GRADIENTS: Record<string, FolderGradient> = {
  green: { from: '#3a7d2c', to: '#7bc24a', letter: 'G' },
  purple: { from: '#5b3da6', to: '#9b6bd8', letter: 'C' },
  teal: { from: '#1f7a4d', to: '#3fc07d', letter: 'H' },
  blue: { from: '#1d3a8a', to: '#5a7fe0', letter: 'AI' },
  pink: { from: '#8a1d4e', to: '#d8567f', letter: 'N' },
  gold: { from: '#7a5a1d', to: '#d8a64a', letter: 'R' },
};

export const FOLDER_LIST = Object.values(FOLDER_GRADIENTS);

export const gradientStyle = (g: FolderGradient): CSSProperties => ({
  backgroundImage: `linear-gradient(135deg, ${g.from}, ${g.to})`,
});
